<template>
  <div class="marketing-products-row">
    <div class="marketing-products-cell image-cell">
      <img
        v-if="imageUrl"
        class="marketing-products-modal-image"
        :src="imageUrl"
        :alt="displayName || articleNumber || ''"
      >
      <div
        v-else
        class="marketing-products-modal-image-placeholder"
        aria-hidden="true"
      >
        <b-icon icon="image" aria-hidden="true" />
      </div>
    </div>
    <div class="marketing-products-cell info-cell">
      <div class="marketing-products-modal-name">
        <a
          v-if="detailUrl"
          :href="detailUrl"
        >{{ displayName }}</a>
        <template v-else>{{ displayName }}</template>
      </div>
      <div class="marketing-products-modal-article-number">
        {{ articleNumber }}
      </div>
    </div>
    <div class="marketing-products-cell action-cell">
      <c-product-basketbutton
        :class="basketButtonClass"
        :product-id="productId"
        :small="small"
        :quantityinfo="quantityinfo"
        :quantity-post-fix-singular="quantityPostFixSingular"
        :quantity-post-fix-plural="quantityPostFixPlural"
        :required-additional-properties-validation="requiredAdditionalPropertiesValidation"
        :error-toast-title="errorToastTitle"
        :translations="basketTranslations"
        :use-i18n="useI18n"
        :enable-marketing-product-upsell="enableMarketingProductUpsell"
      >
        <template
          v-if="isStoreWindow"
          #additionalconfig="{ setAdditionalBasketConfig }"
        >
          <p><strong>{{ safeBasketTranslations.deliveryTimeSlot }}</strong></p>
          <c-calendar-week-selector
            :min-week-date="effectiveCalendarMinDate"
            @calendar-week-select="(dateStart, dateEnd) => setAdditionalBasketConfig({ dateStart, dateEnd })"
          />
        </template>
        <b-icon
          icon="cart"
          :title="safeBasketTranslations.addToBasket"
        />
      </c-product-basketbutton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CLinkedMarketingProduct',
  props: {
    productId: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      default: ''
    },
    displayName: {
      type: String,
      default: ''
    },
    articleNumber: {
      type: String,
      default: ''
    },
    /** PDP: link target for title; omit in modal */
    detailUrl: {
      type: String,
      default: ''
    },
    isStoreWindow: {
      type: Boolean,
      default: false
    },
    /**
     * Optional UTC ms (PDP parity). If unset, `new Date()` is used (modal).
     */
    calendarMinWeekTimestamp: {
      type: Number,
      default: null
    },
    quantityPostFixSingular: {
      type: String,
      default: ''
    },
    quantityPostFixPlural: {
      type: String,
      default: ''
    },
    basketTranslations: {
      type: Object,
      required: true
    },
    requiredAdditionalPropertiesValidation: {
      type: Object,
      default: () => ({})
    },
    errorToastTitle: {
      type: String,
      default: ''
    },
    quantityinfo: {
      type: Object,
      default: () => ({
        min: 1,
        max: 1000,
        step: 1,
        initialStep: 1
      })
    },
    small: {
      type: Boolean,
      default: true
    },
    basketButtonClass: {
      type: String,
      default: 'purchase-basket-select'
    },
    useI18n: {
      type: Boolean,
      default: true
    },
    enableMarketingProductUpsell: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    safeBasketTranslations () {
      const t = this.basketTranslations || {}
      return {
        addToBasket: t.addToBasket || '',
        deliveryTimeSlot: t.deliveryTimeSlot || ''
      }
    },
    effectiveCalendarMinDate () {
      const ts = this.calendarMinWeekTimestamp
      if (ts != null && !Number.isNaN(Number(ts))) {
        return new Date(Number(ts))
      }
      return new Date()
    }
  }
}
</script>
